import { render, staticRenderFns } from "./valuationProduct.vue?vue&type=template&id=dfc6eb10"
import script from "./valuationProduct.vue?vue&type=script&lang=js"
export * from "./valuationProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports